import _asyncToGenerator from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js";
import _regeneratorRuntime from "/builds/timeneye/panel-front-end/node_modules/@babel/runtime-corejs2/regenerator/index.js";
import "core-js/modules/es6.function.name.js";
import "core-js/modules/es7.array.includes.js";
import "core-js/modules/es6.array.find.js";
import Vue from 'vue';
import VueRouter from 'vue-router';
import User from 'src/store/models/User';
import Project from 'src/store/models/Project';
import { omit, forEach } from 'lodash';
import moment from 'moment';
import routes from "./routes";
Vue.use(VueRouter);
/*
 * If not building with SSR mode, you can
 * directly export the Router instantiation;
 *
 * The function below can be async too; either use
 * async/await or return a Promise which resolves
 * with the Router instance.
 */

var Router = new VueRouter({
  scrollBehavior: function scrollBehavior() {
    return {
      x: 0,
      y: 0
    };
  },
  routes: routes,
  // Leave these as they are and change in quasar.conf.js instead!
  // quasar.conf.js -> build -> vueRouterMode
  // quasar.conf.js -> build -> publicPath
  mode: process.env.VUE_ROUTER_MODE,
  base: process.env.VUE_ROUTER_BASE
});
Router.beforeEach( /*#__PURE__*/function () {
  var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(to, from, next) {
    var token;
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            token = localStorage.getItem('access_token');

            if (!(!token && to.query && to.query.access_token)) {
              _context.next = 8;
              break;
            }

            token = to.query.access_token;
            User.setAccessToken(token);

            if (to.query.refresh_token) {
              User.setRefreshToken(to.query.refresh_token);
            }

            if (!User.me() && token) {
              User.$me().then(function () {
                next({
                  path: to.path,
                  query: omit(to.query, 'access_token')
                });
              }).catch(function (error) {
                if (error.response && error.response.status === 403) {
                  next({
                    path: '/unauthorized'
                  });
                } else {
                  next();
                }
              });
            } else {
              next({
                path: to.path,
                query: omit(to.query, 'access_token')
              });
            }

            _context.next = 14;
            break;

          case 8:
            if (!(!token && to.query && to.query.uniq_token)) {
              _context.next = 13;
              break;
            }

            _context.next = 11;
            return User.$loginWithUniqToken(to.query.uniq_token).then(function () {
              User.$me().then(function () {
                next({
                  path: to.path,
                  query: omit(to.query, 'uniq_token')
                });
              });
            }).catch(function (error) {
              if (error.response && error.response.status === 403) {
                next({
                  path: '/unauthorized'
                });
              } else {
                next();
              }
            });

          case 11:
            _context.next = 14;
            break;

          case 13:
            if (token && to.query && to.query.uniq_token) {
              next({
                path: to.path,
                query: omit(to.query, 'uniq_token')
              });
            } else if (!User.me() && token && to.name !== 'unauthorized') {
              User.$me().then(function () {
                next();
              }).catch(function (error) {
                if (error.response && error.response.status === 403 && to.name !== 'unauthorized') {
                  next({
                    name: 'unauthorized'
                  });
                } else {
                  next();
                }
              });
            } else {
              next();
            }

          case 14:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));

  return function (_x, _x2, _x3) {
    return _ref.apply(this, arguments);
  };
}());
Router.beforeEach(function (to, from, next) {
  var user = User.query().where('me', true).first();

  if (to.matched.some(function (record) {
    return record.meta.auth;
  })) {
    // this route requires auth, check if logged in;
    // if not, redirect to login page.
    if (!user) {
      next({
        path: '/login',
        query: {
          redirect: to.fullPath
        }
      });
    } else if (user.environment === 'track' && user.uniq_id) {
      // localStorage.removeItem('access_token')
      window.location.href = process.env.TRACK_URL + '/dashboard?uniqId=' + user.uniq_id;
    }

    if (to.matched.some(function (record) {
      return record.meta.setupCompleted;
    }) && user && !user.setup_all_completed) {
      next({
        path: '/setup'
      });
    }
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  // Check subscribed meta
  var isInSubscribedTree = to.matched.some(function (record) {
    return !!record.meta.subscribed;
  });
  var enforcesSubscription = to.meta && to.meta.subscribed;

  if (isInSubscribedTree) {
    var user = User.query().with('account').where('me', true).first();
    var expirationDate = user.account.is_free ? moment().add(1, 'day').endOf('day') : !user.account.billing_enabled ? moment(user.account.expiration).endOf('day') : moment(user.account.expiration).add(3, 'days').endOf('day');
    var subscriptionExpired = expirationDate.isBefore(moment());

    if (enforcesSubscription !== false) {
      // Check if user is in trial
      if (!user.account.is_free && subscriptionExpired && (to.name !== 'workspace_settings' || !user.is_owner)) {
        if (user.account.is_trial) {
          if (user.is_owner) {
            next({
              name: 'billing'
            });
          } else {
            next({
              name: 'trial-ended'
            });
          }
        } else {
          if (user.is_owner) {
            next({
              name: 'billing'
            });
          } else {
            next({
              name: 'subscription-expired'
            });
          }
        }
      } else {
        next();
      }
    } else {
      if (!subscriptionExpired || user.account.is_free) {
        if (to.name === 'billing' || to.name === 'users') {
          next();
        } else {
          next({
            path: '/dashboard'
          });
        }
      } else {
        switch (to.name) {
          case 'trial-ended':
            if (user.account.is_trial) {
              next();
            } else {
              next({
                name: 'subscription-expired'
              });
            }

            break;

          case 'subscription-expired':
            if (!user.account.is_trial) {
              next();
            } else {
              next({
                name: 'trial-ended'
              });
            }

            break;

          default:
            next();
        }
      }
    }
  } else {
    next();
  }
});
Router.beforeEach(function (to, from, next) {
  var user = User.query().where('me', true).first();

  if (to.matched.some(function (record) {
    return record.meta.setupCompleted === false;
  })) {
    // this route requires auth, check if logged in
    // if not, redirect to login page.
    if (user && user.setup_all_completed) {
      next({
        path: '/dashboard'
      });
    }
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  var user = User.query().with('account').where('me', true).first();
  var nativeIntegrations = ['microsoftteams', 'outlookcalendar', 'microsofttodo', 'planner', 'microsoftproject', 'microsoftteamscalls', 'microsoftpowerbi', 'microsoftpowerautomate', 'asana', 'basecamp', 'basecamp3', 'jira', 'clickup'];

  if (to.matched.some(function (record) {
    var feature = record.meta.feature;

    if (to.name === 'integration_detail' && to.params.integration_code && nativeIntegrations.includes(to.params.integration_code)) {
      feature = "integration_".concat(to.params.integration_code);
    }

    return feature && (!user.account.hasFeatureAccess(feature) || !user.account.hasFeature(feature));
  })) {
    next({
      path: '/dashboard'
    });
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.guest;
  })) {
    // this route requires guest, if the user is logged in redirect to home page
    if (User.me()) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.admin;
  })) {
    // this route requires admin permissions, otherwise redirect to home page
    var me = User.me();

    if (me && !me.is_admin) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.owner;
  })) {
    // this route requires owner permissions, otherwise redirect to home page
    var me = User.me();

    if (me && !me.is_owner) {
      next({
        path: '/'
      });
    }
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.gm;
  })) {
    // this route requires admin or group manager permissions, otherwise redirect to home page
    var me = User.me();

    if (me && !(me.is_admin || me.is_gm)) {
      next({
        path: '/',
        query: {
          redirect: to.fullPath
        }
      });
    }
  }

  next();
});
Router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.project;
  }) && to.params.project_id) {
    var projectHasUser = function projectHasUser(project) {
      var hasUser = project.is_public;
      forEach(project.users, function (user) {
        if (user.user_id === User.me().user_id && user.pivot.is_member) {
          hasUser = true;
        }
      });
      return hasUser || User.me().is_admin;
    };

    var project = Project.query().with('users').find(to.params.project_id);

    if (!project) {
      Project.api().get('/projects/' + to.params.project_id).then(function () {
        project = Project.query().with('users').find(to.params.project_id);

        if (projectHasUser(project) || User.me().is_manager) {
          next();
        } else {
          next({
            path: '/',
            query: {
              redirect: to.fullPath
            }
          });
        }
      }).catch(function () {
        next({
          path: '/',
          query: {
            redirect: to.fullPath
          }
        });
      });
    } else {
      if (projectHasUser(project) || User.me().is_manager) {
        next();
      } else {
        next({
          path: '/',
          query: {
            redirect: to.fullPath
          }
        });
      }
    }
  } else {
    next();
  }
});
Router.beforeEach(function (to, from, next) {
  if (to.matched.some(function (record) {
    return record.meta.pm;
  }) && to.params.project_id) {
    var userIsPM = function userIsPM(project) {
      var isPM = false;
      forEach(project.users, function (user) {
        if (user.user_id === User.me().user_id && user.pivot.is_pm) {
          isPM = true;
        }
      });
      return isPM || User.me().is_admin;
    };

    var project = Project.query().with('users').find(to.params.project_id);

    if (!project) {
      Project.api().get('/projects/' + to.params.project_id).then(function () {
        project = Project.query().with('users').find(to.params.project_id);

        if (!userIsPM(project)) {
          next({
            path: '/',
            query: {
              redirect: to.fullPath
            }
          });
        } else {
          next();
        }
      }).catch(function () {});
    } else {
      if (!userIsPM(project)) {
        next({
          path: '/',
          query: {
            redirect: to.fullPath
          }
        });
      } else {
        next();
      }
    }
  } else {
    next();
  }
});
export default Router;